$(document).ready(() => {

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      window.location.reload();
    }
  })

  $(".add-to").on("click", (el)=>{
    const id = $(el.target).data("id");
    let input = $("input[type='number'][data-id='" + id +"']");
    let val = input.val();
    input.val(parseInt(val)+1);
    changeQuantity(id, parseInt(val)+1);
    //input.change();
  });

  $(".subtract-from").on("click", (el)=>{
    const id = $(el.target).data("id");
    let input = $("input[type='number'][data-id='" + id +"']");
    let val = input.val();
    if (val > 0) {
      input.val(parseInt(val)-1);
      changeQuantity(id, parseInt(val)-1);
      //input.change();
    }
  });
  $(".delete-item").on("click touchstart touchend",(el)=>{
    const id = $(el.target).data("id");
    changeQuantity(id, 0);
    //$(".btn-pink-large").prop("disabled",false);
  })
  $("input[type='number']").on("change", (el)=>{
    const id = $(el.target).data("id");
    changeQuantity(id, el.target.value);
  });
  $(".btn-green-large").on("click", (el)=>{
    $(el.currentTarget).find("span").hide();
    $(el.currentTarget).find(".show-spinner").show();

    jQuery.post("/cart/add.js", {
      quantity: 1,
      id: $(el.currentTarget).data("product")
    }).done((data)=>{
      window.location.reload();
    })
  })

  $(".checkout").on("click", (el)=>{
    $(".checkout").find(".show-spinner").show();
    $(".checkout").find("span").hide();
    $(".checkout").prop("disabled",true);

    window.location.href = "/checkout";
  });

  // shovani animace nacitani kosiku, musime odstranit kvuli callum do kosiku
  $(".table-items .cart-loader").remove();
});

function disableRow(id) {
  const parent = $(".row-item[data-id='" + id + "']");
  $(parent).find(".cell-4 span").hide();
  $(parent).find(".money-mobile span").hide();
  $(parent).find(".show-spinner").show();
  $(parent).find(".delete-item").prop("disabled",true);
  $(parent).find("input").prop("disabled",true);
  $(parent).find(".add-to").prop("disabled",true);
  $(parent).find(".subtract-from").prop("disabled",true);
  //$(".btn-pink-large").prop("disabled",true);
}

function enableRow(id) {
  const parent = $(".row-item[data-id='" + id + "']");
  $(parent).find(".cell-4 span").show();
  $(parent).find(".show-spinner").hide();
  $(parent).find(".money-mobile span").show();
  $(parent).find(".delete-item").prop("disabled",false);
  $(parent).find("input").prop("disabled",false);
  $(parent).find(".add-to").prop("disabled",false);
  $(parent).find(".subtract-from").prop("disabled",false);
  //$(".btn-pink-large").prop("disabled",false);

}

function updateRow(index, data, id) {
  let item = data.items[index];
  const parent = $(".row-item[data-id='" + id + "']");
  $(parent).find(".money-mobile .money-final").text((item.final_line_price / 100).toFixed(2));
  $(parent).find(".cell-4 .money-final").text((item.final_line_price / 100).toFixed(2));
}

function money(num) {
  return (num / 100).toFixed(2);
} 

function updateTotal(data) {
  $(".total .money-final").text((data.total_price / 100).toFixed(2));
  $(".total-discount").text((data.total_discount / 100).toFixed(2));
}

function updateHeaderCart(data) {
  $(".cart-button .cart-price-without-currency").text(money(data.total_price));
  $(".cart-button .roboto").text(data.item_count);
  if (data.item_count == 0) {
    $(".cart-button").removeClass("cart-full");
  }
}

function changeQuantity(id, num) {
  let obj = {};
  obj[id] = num;
  disableRow(id);
  const el = $(".row-item[data-id='" + id + "']");
  const index = $(".table-items > div").index(el)+1;
  jQuery.post("/cart/change.js", {"line": index, quantity: num}).done((data)=>{
    data = JSON.parse(data);
    if (data.item_count == 0) {
      $(".main-cart").hide();
      $(".empty-cart").show();
      updateHeaderCart(data);
      return;
    }
    if (num == 0) {
      $(el).remove();
      updateTotal(data);
      updateHeaderCart(data);
      return;
    }
    updateRow(index-1, data, id);
    enableRow(id);
    updateTotal(data);
    updateHeaderCart(data);
  });
}
